import React, {Component} from "react";
import NewsApiComponent from "../../../../airports/p11v5-nsru-backend/web-services/NewsApiComponent";
import NewsDisplay1 from "./NewsDisplay1";
import Skeleton from "react-loading-skeleton";

class UnfinishedHomeNewsFeed extends Component
{
    constructor(props) {
        super(props);
        this.isNewsReadyToFeed = true
        this.feedStep = 2
        this.feedLimit = this.feedStep
        this.isAutoFeed = false

        var news_category_ids = [4, 5]
        if(props.news_category_ids) news_category_ids = props.news_category_ids
        if(props.is_auto_feed) this.isAutoFeed = props.is_auto_feed

        this.state = {
            news_category_ids: news_category_ids,
            newsCount: 0,
            positionIds: [],
            feedIndicator: ""
        };
    }

    componentDidMount() {
        this.feed()
        window.onscroll = this.handleScroll
    }

    componentDidUpdate(prevProps) {

    }

    shouldComponentUpdate(nextProps) {
        this.isAutoFeed = nextProps.is_auto_feed
        this.handleScroll()
        return true
    }


    feed()
    {
        if(this.isNewsReadyToFeed)
        {
            this.setState({
                feedIndicator: (
                    <Skeleton style={{ borderRadius: "20px" }} />
                )
            })
            this.isNewsReadyToFeed = false
            this.feedLimit += this.feedStep

            const newsApi = new NewsApiComponent();
            newsApi.indexNews(this.state.news_category_ids, this.feedLimit, res => {
                var tempPositionIds = this.state.positionIds;
                res.map((news,i) => {
                    tempPositionIds[i] = news.id;
                    const state = {
                        newsCount: i + 1,
                        positionIds: tempPositionIds
                    };
                    this.setState(state);
                });

                this.setState({
                    feedIndicator: ""
                })
                this.isNewsReadyToFeed = true
            });
        }

    }

    handleScroll = (e) => {
        if(
            window.scrollY > (document.documentElement.scrollHeight - (window.innerHeight * 3))
            && this.isAutoFeed
        ) {
            this.feed()
        }
    }

    render() {
        return (
            <>
                <div className={{
                    overflow: "hidden"
                }}>
                    {this.state.positionIds.map((value, key) => {
                        return <NewsDisplay1 id={value} key={key} />
                    })}
                    {this.state.feedIndicator}
                </div>

            </>
        );
    }

}
export default UnfinishedHomeNewsFeed;
